var changer = require('./themeColorChanger.js')
var varyColor = require('./varyColor')

module.exports = {
    changer: changer,
    varyColor: varyColor
}
